import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const names = ['Martín G.', 'Lucas R.', 'Sofía M.', 'Camila P.', 'Juan D.', 'Andrea L.', 'Fernando S.', 'Micaela V.', 'Diego A.', 'Valentina C.'];
const INTERVAL_MS = 30000; // 30s between popups
const VISIBLE_MS = 5000; // popup stays visible 5s
const INITIAL_DELAY_MS = 8000; // wait 8s before showing the first one
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    time: ''
  });
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setData({
        name: randomName,
        time: `${randomTime} min`
      });
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), VISIBLE_MS);
    };
    const initialTimer = setTimeout(showPopup, INITIAL_DELAY_MS);
    const interval = setInterval(showPopup, INTERVAL_MS);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up" data-id="element-247" data-mp="1fxn0juk1i6gy">
      <div className="bg-white border border-stone-200 rounded-xl shadow-xl p-4 flex items-start gap-4 pr-10 relative max-w-sm" data-id="element-248" data-mp="1ax7p58jbj91m">
        <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-stone-400 hover:text-stone-600" aria-label="Cerrar" data-id="element-249" data-mp="n8y78hp875fr">
          <X className="w-4 h-4" data-id="element-250" data-mp="x6m3xd6e6n0k" />
        </button>

        <div className="bg-green-50 p-2 rounded-full flex-shrink-0" data-id="element-251" data-mp="s5ojsv1tniwf">
          <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-252" data-mp="28kg40kotdjun" />
        </div>

        <div data-id="element-253" data-mp="28imxr6i451n6">
          <p className="text-sm text-stone-600" data-id="element-254" data-mp="28mapq17wtfzs">
            <span className="font-bold text-stone-900" data-id="element-255" data-mp="23kbmqsg30l3d">{data.name}</span> acaba
            de comprar
          </p>
          <p className="text-xs text-coral-500 font-bold mt-1" data-id="element-256" data-mp="2anrynerhvqm6">
Megapack Funcional 360
          </p>
          <p className="text-xs text-stone-400 mt-1" data-id="element-257" data-mp="2fm35dgmhtl06">Hace {data.time}</p>
        </div>
      </div>
    </div>;
}